module.exports = function getResource(label, vars = []) {
    let resources = {
        back: 'Retour'
    };

    return resources[label];
};
